// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isNumber(value) {
  return typeof value === 'number';
}
export { default as mergeWith } from 'lodash.mergewith';
export const TransitionEasings = {
  ease: [0.25, 0.1, 0.25, 1],
  easeIn: [0.4, 0, 1, 1],
  easeOut: [0, 0, 0.2, 1],
  easeInOut: [0.4, 0, 0.2, 1]
};
export const TransitionVariants = {
  scale: {
    enter: {
      scale: 1
    },
    exit: {
      scale: 0.95
    }
  },
  fade: {
    enter: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  },
  pushLeft: {
    enter: {
      x: '100%'
    },
    exit: {
      x: '-30%'
    }
  },
  pushRight: {
    enter: {
      x: '-100%'
    },
    exit: {
      x: '30%'
    }
  },
  pushUp: {
    enter: {
      y: '100%'
    },
    exit: {
      y: '-30%'
    }
  },
  pushDown: {
    enter: {
      y: '-100%'
    },
    exit: {
      y: '30%'
    }
  },
  slideLeft: {
    position: {
      left: 0,
      top: 0,
      bottom: 0,
      width: '100%'
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: '-100%',
      y: 0
    }
  },
  slideRight: {
    position: {
      right: 0,
      top: 0,
      bottom: 0,
      width: '100%'
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: '100%',
      y: 0
    }
  },
  slideUp: {
    position: {
      top: 0,
      left: 0,
      right: 0,
      maxWidth: '100vw'
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: 0,
      y: '-100%'
    }
  },
  slideDown: {
    position: {
      bottom: 0,
      left: 0,
      right: 0,
      maxWidth: '100vw'
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: 0,
      y: '100%'
    }
  }
};
export function slideTransition(options) {
  var _options$direction;
  const side = (_options$direction = options === null || options === void 0 ? void 0 : options.direction) !== null && _options$direction !== void 0 ? _options$direction : 'right';
  switch (side) {
    case 'right':
      return TransitionVariants.slideRight;
    case 'left':
      return TransitionVariants.slideLeft;
    case 'bottom':
      return TransitionVariants.slideDown;
    case 'top':
      return TransitionVariants.slideUp;
    default:
      return TransitionVariants.slideRight;
  }
}
export const TransitionDefaults = {
  enter: {
    duration: 0.2,
    ease: TransitionEasings.easeOut
  },
  exit: {
    duration: 0.1,
    ease: TransitionEasings.easeIn
  }
};
export const withDelay = {
  enter: (transition, delay) => ({
    ...transition,
    delay: isNumber(delay) ? delay : delay === null || delay === void 0 ? void 0 : delay['enter']
  }),
  exit: (transition, delay) => ({
    ...transition,
    delay: isNumber(delay) ? delay : delay === null || delay === void 0 ? void 0 : delay['exit']
  })
};